import { Component, Input, OnInit } from '@angular/core';
import {
  HeadingColor,
  HeadingType,
  HeadingWeight,
} from '@freelancer/ui/heading';
import { TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-user-profile-summary-tagline',
  template: `
    <fl-heading
      *ngIf="tagline"
      class="Tagline"
      [weight]="HeadingWeight.NORMAL"
      [size]="TextSize.MID"
      [headingType]="HeadingType.H2"
      [color]="HeadingColor.MID"
    >
      {{ tagline }}
    </fl-heading>
  `,
  styleUrls: ['./user-profile-summary-tagline.component.scss'],
})
export class UserProfileSummaryTaglineComponent implements OnInit {
  TextSize = TextSize;
  HeadingColor = HeadingColor;
  HeadingType = HeadingType;
  HeadingWeight = HeadingWeight;

  @Input() tagline?: string;

  taglineMaxLength = 270;

  ngOnInit() {
    if (this.tagline) {
      this.tagline =
        this.tagline.length > this.taglineMaxLength
          ? `${this.tagline.slice(0, this.taglineMaxLength - 3)}...`
          : this.tagline;
    }
  }
}
